import SecureStorage from 'secure-web-storage';
import crypto from 'crypto';

// Must be exactly 32 bytes (AES-256 key)
const SECRET_KEY = process.env.REACT_APP_SECURE_STORE_KEY;

if (!SECRET_KEY || Buffer.from(SECRET_KEY).length !== 32) {
  console.error('❌ SECRET_KEY must be exactly 32 bytes for AES-256');
}

const IV = Buffer.alloc(16, 0); // 16 bytes of zero — for AES-256-CBC

const secureStorage = new SecureStorage(localStorage, {
  hash: function (key) {
    return crypto.createHash('sha256').update(String(key)).digest('hex');
  },
  encrypt: function (data) {
    if (!data) return null;
    try {
      const cipher = crypto.createCipheriv(
        'aes-256-cbc',
        Buffer.from(SECRET_KEY),
        IV,
      );
      let encrypted = cipher.update(String(data), 'utf8', 'base64');
      encrypted += cipher.final('base64');
      return encrypted;
    } catch (err) {
      console.error('Encryption failed:', err);
      return null;
    }
  },
  decrypt: function (data) {
    if (!data) return null;
    try {
      const decipher = crypto.createDecipheriv(
        'aes-256-cbc',
        Buffer.from(SECRET_KEY),
        IV,
      );
      let decrypted = decipher.update(String(data), 'base64', 'utf8');
      decrypted += decipher.final('utf8');
      return decrypted;
    } catch (err) {
      console.error('Decryption failed:', err);
      return null;
    }
  },
});

export default secureStorage;
